import React from 'react';
import { Icon, Divider,Row,Col } from 'antd';
import { Pie, Line, Bar, Liquid, Scatter } from '@antv/g2plot';
import 'antd/dist/antd.css';
import './dataView.css';
import '../../scripts/config'

class DataViewOnePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectKey: '0',
            chart1: [
                { type: '首次建册', value: 2340 },
                { type: '二胎建册', value: 105 },
                { type: '其他', value: 61 },
            ],
            lineData: [
                {
                    "name": "建档",
                    "year": "08:00",
                    "gdp": 1
                }, {
                    "name": "建档",
                    "year": "09:00",
                    "gdp": 12
                }, {
                    "name": "建档",
                    "year": "10:00",
                    "gdp": 26
                }, {
                    "name": "建档",
                    "year": "11:00",
                    "gdp": 37
                }, {
                    "name": "建档",
                    "year": "12:00",
                    "gdp": 15
                }, {
                    "name": "建档",
                    "year": "13:00",
                    "gdp": 0
                }, {
                    "name": "建档",
                    "year": "14:00",
                    "gdp": 4
                }, {
                    "name": "建档",
                    "year": "15:00",
                    "gdp": 26
                }, {
                    "name": "建档",
                    "year": "16:00",
                    "gdp": 31
                }, {
                    "name": "建档",
                    "year": "17:00",
                    "gdp": 29
                }, {
                    "name": "建档",
                    "year": "18:00",
                    "gdp": 3
                },
                {
                    "name": "首诊",
                    "year": "08:00",
                    "gdp": 2
                }, {
                    "name": "首诊",
                    "year": "09:00",
                    "gdp": 11
                }, {
                    "name": "首诊",
                    "year": "10:00",
                    "gdp": 18
                }, {
                    "name": "首诊",
                    "year": "11:00",
                    "gdp": 34
                }, {
                    "name": "首诊",
                    "year": "12:00",
                    "gdp": 6
                }, {
                    "name": "首诊",
                    "year": "13:00",
                    "gdp": 0
                }, {
                    "name": "首诊",
                    "year": "14:00",
                    "gdp": 3
                }, {
                    "name": "首诊",
                    "year": "15:00",
                    "gdp": 29
                }, {
                    "name": "首诊",
                    "year": "16:00",
                    "gdp": 14
                }, {
                    "name": "首诊",
                    "year": "17:00",
                    "gdp": 12
                }, {
                    "name": "首诊",
                    "year": "18:00",
                    "gdp": 6
                },
                {
                    "name": "复诊",
                    "year": "08:00",
                    "gdp": 4
                }, {
                    "name": "复诊",
                    "year": "09:00",
                    "gdp": 48
                }, {
                    "name": "复诊",
                    "year": "10:00",
                    "gdp": 29
                }, {
                    "name": "复诊",
                    "year": "11:00",
                    "gdp": 42
                }, {
                    "name": "复诊",
                    "year": "12:00",
                    "gdp": 7
                }, {
                    "name": "复诊",
                    "year": "13:00",
                    "gdp": 0
                }, {
                    "name": "复诊",
                    "year": "14:00",
                    "gdp": 8
                }, {
                    "name": "复诊",
                    "year": "15:00",
                    "gdp": 31
                }, {
                    "name": "复诊",
                    "year": "16:00",
                    "gdp": 24
                }, {
                    "name": "复诊",
                    "year": "17:00",
                    "gdp": 30
                }, {
                    "name": "复诊",
                    "year": "18:00",
                    "gdp": 15
                }
            ],
            barData: [
                { year: '无风险', value: 302 },
                { year: '黄色风险', value: 98 },
                { year: '橙色风险', value: 32 },
                { year: '红色风险', value: 10 },
                { year: '紫色风险', value: 1 },
            ],
            scatterData: [
                { "x": 42, "y": 38, "size": 3500, "genre": "建档人数", "unit": "人" },
                { "x": 6, "y": 18, "size": 2100, "genre": "早孕建档", "unit": "人" },
                { "x": 57, "y": 2, "size": 6800, "genre": "产检人次", "unit": "次" },
                { "x": 68, "y": 26, "size": 4021, "genre": "产检大于5次", "unit": "次" },
                { "x": 80, "y": 76, "size": 681, "genre": "高危建档", "unit": "人" },
                { "x": 11, "y": 74, "size": 420, "genre": "黄色风险", "unit": "人" },
                { "x": 88, "y": 56, "size": 160, "genre": "橙色风险", "unit": "人" },
                { "x": 30, "y": 47, "size": 21, "genre": "红色风险", "unit": "人" },
                { "x": 57, "y": 62, "size": 4, "genre": "紫色风险", "unit": "人" },
                { "x": 4, "y": 16, "size": 3021, "genre": "三病筛查", "unit": "人" },
                { "x": 46, "y": 10, "size": 2860, "genre": "首次建档", "unit": "人" },
                { "x": 22, "y": 87, "size": 1600, "genre": "二胎建档", "unit": "人" },
                { "x": 57, "y": 91, "size": 40, "genre": "二胎以上", "unit": "人" },
                { "x": 45, "y": 15, "size": 12, "genre": "年龄小于18岁", "unit": "人" },
                { "x": 9, "y": 81, "size": 680, "genre": "年龄大于35岁", "unit": "人" },
                { "x": 98, "y": 5, "size": 16, "genre": "临产孕妇", "unit": "人" },
                { "x": 51, "y": 50, "size": 806, "genre": "产后复诊", "unit": "人" },
                { "x": 41, "y": 22, "size": 4, "genre": "流失孕妇", "unit": "人" }
            ]
        }
    };
    //组件载入完成
    componentDidMount() {
        this.pieOnInit();
        this.lineOnInit();
        this.barOnInit();
        this.LiquidOnInit();
        this.scatterOnInit();
    }

    pieOnInit = () => {
        const data = this.state.chart1;
        const piePlot = new Pie('pieOnecontainer', {
            appendPadding: 10,
            data,
            angleField: 'value',
            colorField: 'type',
            radius: 1,
            innerRadius: 0.6,
            color: ['#0DB65F', '#E6ED12', '#F8BA0C'],
            label: {
                type: 'inner',
                offset: '-50%',
                content: '{value}',
                style: {
                    textAlign: 'center',
                    fontSize: 14,
                },
            },
            legend: {
                position: 'bottom'
            },
            interactions: [{ type: 'element-selected' }, { type: 'element-active' }],
            statistic: {
                title: false,
                content: {
                    style: {
                        whiteSpace: 'pre-wrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }
                },
            },
            animation: {
                appear: {
                    duration: 3000,
                },
            },
        });

        piePlot.render();
    }

    lineOnInit = () => {
        const data = this.state.lineData;
        const linePlot = new Line('lineOnecontainer', {
            data,
            xField: 'year',
            yField: 'gdp',
            seriesField: 'name',
            yAxis: {
                label: {
                    formatter: (v) => `${v} 人`,
                },
            },
            color: ['#0DF54C', '#0FBFE7', '#FFFFFF'],
            legend: {
                position: 'bottom',
            },
            smooth: true,
            // @TODO 后续会换一种动画方式
            animation: {
                appear: {
                    animation: 'path-in',
                    duration: 5000,
                },
            },
        });

        linePlot.render();
    }
    barOnInit = () => {
        const data = this.state.barData;
        const bar = new Bar('barcontainer', {
            data,
            xField: 'value',
            yField: 'year',
            color: ['purple', 'red', 'orange', 'yellow', 'green'],
            seriesField: 'year',
            legend: {
                position: 'bottom',
            }
        });

        bar.render();
    }
    LiquidOnInit = () => {
        const liquidPlot = new Liquid('Liquidcontainer', {
            percent: 0.85,
            shape: function (x, y, width, height) {
                const r = width / 4;
                const dx = x - width / 2;
                const dy = y - height / 2;
                return [
                    ['M', dx, dy + r * 2],
                    ['A', r, r, 0, 0, 1, x, dy + r],
                    ['A', r, r, 0, 0, 1, dx + width, dy + r * 2],
                    ['L', x, dy + height],
                    ['L', dx, dy + r * 2],
                    ['Z'],
                ];
            },
            statistic: {
                title: {
                    formatter: () => '孕妇稳定率',
                    style: ({ percent }) => ({
                        fill: percent > 0.65 ? 'white' : '#F6F837',
                    }),
                },
                content: {
                    style: ({ percent }) => ({
                        fontSize: 24,
                        lineHeight: 1,
                        fill: percent > 0.65 ? 'white' : '#F6F837',
                    })
                },
            },
            outline: {
                border: 2,
                distance: 0,
                style: {
                    stroke: 'rgba(255, 80, 129, 1)',
                    strokeOpacity: 0.65,
                },
            },
            theme: {
                styleSheet: {
                    brandColor: 'rgba(255, 80, 129, 1)',
                },
            },
            wave: {
                length: 128,
            },
        });

        liquidPlot.render();
    }
    scatterOnInit = () => {
        const data = this.state.scatterData;
        const scatterPlot = new Scatter('scattercontainer', {
            appendPadding: 30,
            data,
            xField: 'x',
            yField: 'y',
            colorField: 'genre',
            color: [
                'r(0.4, 0.3, 0.7) 0:rgba(255,255,255,1) 1:#FE2727',
                'r(0.4, 0.4, 0.7) 0:rgba(255,255,255,1) 1:#FEA927',
                'r(0.4, 0.4, 0.7) 0:rgba(255,255,255,1) 1:#FEF027',
                'r(0.4, 0.4, 0.7) 0:rgba(255,255,255,1) 1:#77FE27',
                'r(0.4, 0.4, 0.7) 0:rgba(255,255,255,1) 1:#2FF20C',
                'r(0.4, 0.4, 0.7) 0:rgba(255,255,255,1) 1:#0CF2C3',
                'r(0.4, 0.4, 0.7) 0:rgba(255,255,255,1) 1:#0CD5F2',
                'r(0.4, 0.4, 0.7) 0:rgba(255,255,255,1) 1:#0C8DF2',
                'r(0.4, 0.4, 0.7) 0:rgba(255,255,255,1) 1:#0C4FF2',
                'r(0.4, 0.4, 0.7) 0:rgba(255,255,255,1) 1:#A40CF2',
                'r(0.4, 0.4, 0.7) 0:rgba(255,255,255,1) 1:#F20CE7',
                'r(0.4, 0.4, 0.7) 0:rgba(255,255,255,1) 1:#F20CA4',
                'r(0.4, 0.4, 0.7) 0:rgba(255,255,255,1) 1:#F20C4F',
                'r(0.4, 0.4, 0.7) 0:rgba(255,255,255,1) 1:#F20C19',
            ],
            sizeField: 'size',
            size: [5, 50],
            shape: 'circle',
            yAxis: {
                nice: false,
                line: false,
                grid: {
                    line: false,
                },
                label: false
            },
            xAxis: {
                nice: false,
                grid: {
                    line: false,
                },
                line: false,
                label: false
            },
            tooltip: {
                formatter: (datum) => {
                    return { name: datum.genre, value: datum.size };
                },
            }
        });
        scatterPlot.render();
    }

    menClick = (index) => {
        this.setState({ selectKey: index });
    }
    render() {
        return (
            <div>
                <Row gutter={4} className="dv-c-data">
                    <Col span={6}>
                        <Row gutter={2} className='dv-c-data-content'>
                            <Col span={12}>
                                <Row className='dv-c-data-content-row'>
                                    <Col span={6} className='dv-c-data-content-row-icon' style={{ color: '#ffff43' }}>
                                        <Icon type='file-protect'></Icon>
                                    </Col>
                                    <Col span={18} className='dv-c-data-content-row-data'>
                                        <div>累计建册孕妇（人）</div>
                                        <div style={{ color: '#ffff43' }}>2460</div>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={12}>
                                <Row className='dv-c-data-content-row'>
                                    <Col span={6} className='dv-c-data-content-row-icon' style={{ color: '#ffff43' }}>
                                        <Icon type='file-protect'></Icon>
                                    </Col>
                                    <Col span={18} className='dv-c-data-content-row-data'>
                                        <div>本月建册孕妇（人）</div>
                                        <div style={{ color: '#ffff43' }}>320</div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={6}>
                        <Row gutter={2} className='dv-c-data-content'>
                            <Col span={12}>
                                <Row className='dv-c-data-content-row'>
                                    <Col span={6} className='dv-c-data-content-row-icon' style={{ color: '#25f3e6' }}>
                                        <Icon type='smile'></Icon>
                                    </Col>
                                    <Col span={18} className='dv-c-data-content-row-data'>
                                        <div>累计产检服务（次）</div>
                                        <div style={{ color: '#25f3e6' }}>6850</div>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={12}>
                                <Row className='dv-c-data-content-row'>
                                    <Col span={6} className='dv-c-data-content-row-icon' style={{ color: '#25f3e6' }}>
                                        <Icon type='smile'></Icon>
                                    </Col>
                                    <Col span={18} className='dv-c-data-content-row-data'>
                                        <div>本月产检服务（次）</div>
                                        <div style={{ color: '#25f3e6' }}>92</div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={6}>
                        <Row gutter={2} className='dv-c-data-content'>
                            <Col span={12}>
                                <Row className='dv-c-data-content-row'>
                                    <Col span={6} className='dv-c-data-content-row-icon' style={{ color: '#ff4e4e' }}>
                                        <Icon type='alert'></Icon>
                                    </Col>
                                    <Col span={18} className='dv-c-data-content-row-data'>
                                        <div>累计筛查高危（人）</div>
                                        <div style={{ color: '#ff4e4e' }}>1308</div>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={12}>
                                <Row className='dv-c-data-content-row'>
                                    <Col span={6} className='dv-c-data-content-row-icon' style={{ color: '#ff4e4e' }}>
                                        <Icon type='alert'></Icon>
                                    </Col>
                                    <Col span={18} className='dv-c-data-content-row-data'>
                                        <div>本月筛查高危（人）</div>
                                        <div style={{ color: '#ff4e4e' }}>213</div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={6}>
                        <Row gutter={2} className='dv-c-data-content'>
                            <Col span={12}>
                                <Row className='dv-c-data-content-row'>
                                    <Col span={6} className='dv-c-data-content-row-icon' style={{ color: '#24EF48' }}>
                                        <Icon type='heart'></Icon>
                                    </Col>
                                    <Col span={18} className='dv-c-data-content-row-data'>
                                        <div>累计骨盆恢复（人）</div>
                                        <div style={{ color: '#24EF48' }}>209</div>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={12}>
                                <Row className='dv-c-data-content-row'>
                                    <Col span={6} className='dv-c-data-content-row-icon' style={{ color: '#24EF48' }}>
                                        <Icon type='heart'></Icon>
                                    </Col>
                                    <Col span={18} className='dv-c-data-content-row-data'>
                                        <div>本月骨盆恢复（人）</div>
                                        <div style={{ color: '#24EF48' }}>78</div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row gutter={6} className="div-c-charts">
                    <Col span={6}>
                        <Row gutter={1}>

                            <Col span={24}>
                                <div className="div-c-charts-content">
                                    <div className="div-c-charts-content-title"><Icon type='pie-chart'></Icon><Divider type='vertical'></Divider>建档人群分类</div>
                                    <div id='pieOnecontainer'></div>
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={1}>
                            <Col span={24}>
                                <div className="div-c-charts-content">
                                    <div className="div-c-charts-content-title"><Icon type='exception'></Icon><Divider type='vertical'></Divider>妊娠风险筛查</div>
                                    <div id='barcontainer'></div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={12}>
                        <div className="div-c-charts-content-center">
                            <div className="div-c-charts-content-title"><Icon type='cluster'></Icon><Divider type='vertical'></Divider>产科门诊综合情况</div>
                            <div id='scattercontainer'></div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <Row gutter={1}>
                            <Col span={24}>
                                <div className="div-c-charts-content">
                                    <div className="div-c-charts-content-title"><Icon type='audit'></Icon><Divider type='vertical'></Divider>当日工作情况</div>
                                    <div id='lineOnecontainer'></div>
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={1}>
                            <Col span={24}>
                                <div className="div-c-charts-content">
                                    <div className="div-c-charts-content-title"><Icon type='schedule'></Icon><Divider type='vertical'></Divider>按时产检/随访情况</div>
                                    <div id='Liquidcontainer'></div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        );
    }
}
export default DataViewOnePage;